export enum NotificationDisplayType {
    Default,
    Toast,
    InPage
}

export enum NotificationTimeout {
    Default,
    Never
}

export enum NotificationSeverity {
    INFO,
    WARNING,
    ERROR,
    SUCCESS
}

export class NotificationUtil {

    private static INPAGE_DISPLAY_SELECTOR: string = "#alert-container";
    private static ALERT_COUNTER: number = 0;

    public static Info(contentHtml: string, title: string = 'Információ', timeout: NotificationTimeout = NotificationTimeout.Default, type: NotificationDisplayType = NotificationDisplayType.Default) {

        if (type == NotificationDisplayType.Default) {
            type = NotificationUtil.ResolveDefaultNotificationType();
        }

        let timeoutInMs = NotificationUtil.ResolveNotificationTimeout(type, NotificationSeverity.INFO, timeout);

        switch (type) {
            case NotificationDisplayType.Toast:
                NotificationUtil.DisplayToast(contentHtml, title, timeoutInMs, NotificationSeverity.INFO);
                break;
            case NotificationDisplayType.InPage:
                NotificationUtil.DisplayInPage(contentHtml, title, timeoutInMs, NotificationSeverity.INFO);
                break;
        }
    }

    public static Warning(contentHtml: string, title: string = 'Figyelem', timeout: NotificationTimeout = NotificationTimeout.Default, type: NotificationDisplayType = NotificationDisplayType.Default) {

        if (type == NotificationDisplayType.Default) {
            type = NotificationUtil.ResolveDefaultNotificationType();
        }

        let timeoutInMs = NotificationUtil.ResolveNotificationTimeout(type, NotificationSeverity.WARNING, timeout);

        switch (type) {
            case NotificationDisplayType.Toast:
                NotificationUtil.DisplayToast(contentHtml, title, timeoutInMs, NotificationSeverity.WARNING);
                break;
            case NotificationDisplayType.InPage:
                NotificationUtil.DisplayInPage(contentHtml, title, timeoutInMs, NotificationSeverity.WARNING);
                break;
        }
    }

    public static Error(contentHtml: string, title: string = 'Hiba történt', timeout: NotificationTimeout = NotificationTimeout.Default, type: NotificationDisplayType = NotificationDisplayType.Default) {

        if (type == NotificationDisplayType.Default) {
            type = NotificationUtil.ResolveDefaultNotificationType();
        }

        let timeoutInMs = NotificationUtil.ResolveNotificationTimeout(type, NotificationSeverity.ERROR, timeout);

        switch (type) {
            case NotificationDisplayType.Toast:
                NotificationUtil.DisplayToast(contentHtml, title, timeoutInMs, NotificationSeverity.ERROR);
                break;
            case NotificationDisplayType.InPage:
                NotificationUtil.DisplayInPage(contentHtml, title, timeoutInMs, NotificationSeverity.ERROR);
                break;
        }
    }

    public static Success(contentHtml: string, title: string = 'Siker', timeout: NotificationTimeout = NotificationTimeout.Default, type: NotificationDisplayType = NotificationDisplayType.Default) {

        if (type == NotificationDisplayType.Default) {
            type = NotificationUtil.ResolveDefaultNotificationType();
        }

        let timeoutInMs = NotificationUtil.ResolveNotificationTimeout(type, NotificationSeverity.SUCCESS, timeout);

        switch (type) {
            case NotificationDisplayType.Toast:
                NotificationUtil.DisplayToast(contentHtml, title, timeoutInMs, NotificationSeverity.SUCCESS);
                break;
            case NotificationDisplayType.InPage:
                NotificationUtil.DisplayInPage(contentHtml, title, timeoutInMs, NotificationSeverity.SUCCESS);
                break;
        }
    }

    private static ResolveDefaultNotificationType(): NotificationDisplayType {
        if (this.CanDisplayErrorInPage()) {
            return NotificationDisplayType.InPage;
        }
        else {
            return NotificationDisplayType.Toast;
        }
    }

    private static ResolveNotificationTimeout(type: NotificationDisplayType, severity: NotificationSeverity, timeout: NotificationTimeout): number {

        if (timeout == NotificationTimeout.Never) {
            return -1;
        }

        switch (type) {
            case NotificationDisplayType.InPage:
                return NotificationUtil.ResolveInPageTimeout(severity);
            case NotificationDisplayType.Toast:
                return NotificationUtil.ResolveToastTimeout(severity);
        }
    }

    private static ResolveInPageTimeout(severity: NotificationSeverity): number {
        return -1;
    }

    private static ResolveToastTimeout(severity: NotificationSeverity): number {
        switch (severity) {
            case NotificationSeverity.INFO:
                return 5000;
            case NotificationSeverity.WARNING:
                return 20000;
            case NotificationSeverity.ERROR:
                return -1;
            case NotificationSeverity.SUCCESS:
                return 5000;
        }
    }

    private static DisplayToast(contentHtml: string, title: string, timeoutInMs: number, severity: NotificationSeverity) {

        let toastTemplate: HTMLTemplateElement = document.querySelector('#toast-template');

        let clone: HTMLDivElement = toastTemplate.content.cloneNode(true) as HTMLDivElement;

        clone.querySelector('.toast-header-text').innerHTML = title;
        clone.querySelector('.toast-body').innerHTML = contentHtml;
        clone.querySelector('.toast-severity').classList.add(this.GetToastClassNameFromSeverity(severity));

        let $clone = $(clone);

        $('#toast-container').append($clone);

        $('#toast-container')
            .find('.toast:last')
            .toast({
                delay: timeoutInMs > 0 ? timeoutInMs : 0,
                autohide: timeoutInMs > 0,
                animation: true
            })
            .toast('show');
    }

    private static DisplayInPage(contentHtml: string, title: string, timeoutInMs: number, severity: NotificationSeverity) {

        let notificationContainer = $(this.INPAGE_DISPLAY_SELECTOR);

        ++NotificationUtil.ALERT_COUNTER;

        notificationContainer.append(`
<div class="alert ${NotificationUtil.GetAlertClassNameFromSeverity(severity)} d-flex" data-alert-id="${NotificationUtil.ALERT_COUNTER}">
  <p class="mb-0">
    <strong>${title}</strong>
    ${contentHtml}
  </p>
  <button type="button" class="close ml-auto align-self-start" data-dismiss="alert" aria-label="Figyelmeztetés elrejtése">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
`);
        if (timeoutInMs > 0) {
            let counter = NotificationUtil.ALERT_COUNTER;

            window.setTimeout(() => {
                $(`[data-alert-id="${counter}"]`).remove();
            },
                timeoutInMs);
        }
    }

    private static GetToastClassNameFromSeverity(severity: NotificationSeverity) {
        switch (severity) {
            case NotificationSeverity.INFO:
                return "bg-info";
            case NotificationSeverity.WARNING:
                return "bg-warning";
            case NotificationSeverity.ERROR:
                return "bg-danger";
            case NotificationSeverity.SUCCESS:
                return "bg-success";
        }
    }

    private static GetAlertClassNameFromSeverity(severity: NotificationSeverity) {
        switch (severity) {
            case NotificationSeverity.INFO:
                return "alert-info-oeny";
            case NotificationSeverity.WARNING:
                return "alert-warning-oeny";
            case NotificationSeverity.ERROR:
                return "alert-danger-oeny";
            case NotificationSeverity.SUCCESS:
                return "alert-success-oeny";
        }
    }

    private static CanDisplayErrorInPage(): boolean {
        return $(this.INPAGE_DISPLAY_SELECTOR).length > 0;
    }
}

export default NotificationUtil;
